import { COLORS_BASE } from '@/core/values/core.values';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
class EdCopyrights extends Vue {

  private date:number = new Date().getFullYear();

  get classes(): any {
    let color = this.$store.state.AppStore.copyrights.color;
    return {
      'ed-copyrights--light': color == COLORS_BASE.LIGHT
    };
  }
}

export default Vue.component('ed-copyrights', EdCopyrights);